import React from 'react'
import { FaMapLocationDot } from "react-icons/fa6";
import { TfiEmail } from "react-icons/tfi";
import { TbDeviceLandlinePhone } from "react-icons/tb";
import { PiMailboxBold } from "react-icons/pi";
import { FaFacebookF } from "react-icons/fa";
import { IoLogoInstagram } from "react-icons/io";
import { CiLinkedin } from "react-icons/ci";
import { CiTwitter } from "react-icons/ci";
import { FaFirefoxBrowser } from "react-icons/fa";
import { 
    FooterWrapper,
    Heading,
    ContactGrid,
    ContactItem,
    Icon,
    TextContainer,
    Title,
    Description,
    NewsletterLabel,
    EmailInput,
    SubscribeButton,
    FooterBottom,
    FooterLogo,
    DisclaimerText,
    CopyrightSection,
    CopyrightText,
    PoweredByText,
    SocialMediaContainer,
    SocialMediaLink
  } from '../styles/FooterStyles';

const Footer = () => {
  return (
    <FooterWrapper>
      <Heading>Sophia Matthew Group</Heading>

      <ContactGrid>
        <div>
          <ContactItem>
            <Icon><FaMapLocationDot /></Icon>
            <TextContainer>
              <Title>Address</Title>
              <Description>11911 San Vicente Blvd. Suite 330, Los Angeles, CA 90049</Description>
            </TextContainer>
          </ContactItem>

          <ContactItem>
            <Icon><TfiEmail /></Icon>
            <TextContainer>
              <Title>Email</Title>
              <Description><a href='#home' className='text-gray-900 no-underline'>sophia@sophiamatthew.com</a></Description>
            </TextContainer>
          </ContactItem>
        </div>

        <div>
          <ContactItem>
            <Icon><TbDeviceLandlinePhone /></Icon>
            <TextContainer>
              <Title>Phone Number</Title>
              <Description>123-456-7890</Description>
            </TextContainer>
          </ContactItem>
        </div>

        <div>
          <ContactItem>
            <Icon><PiMailboxBold /></Icon>
            <TextContainer>
              <Title>Newsletter</Title>
              <NewsletterLabel>Email Address</NewsletterLabel>
              <EmailInput type="text" placeholder="Enter Email" />
              <SubscribeButton>Subscribe</SubscribeButton>
            </TextContainer>
          </ContactItem>
        </div>
      </ContactGrid>

      <FooterBottom>
        <FooterLogo src="/assets/images/logo.png" alt="Logo" />
        <DisclaimerText>
          Prime Realty | International Real Estate is a real estate broker licensed by the State of New York and abides by Equal Housing Opportunity laws. License Number 02587463.
          All material presented herein is intended for informational purposes only and is compiled from sources deemed reliable but has not been verified. 
          Changes in price, condition, sale, or withdrawal may be made without notice. No statement is made as to the accuracy of any description. All measurements and square footage are approximate.
          If your property is currently listed for sale, this is not a solicitation. Prime Realty | International Real Estate DRE# 02587463 Sophia Matthew DRE# 02754892.
        </DisclaimerText>
      </FooterBottom>

      <CopyrightSection>
        <CopyrightText>
          Copyright © 2024 | All the images in the site are designed by <a href="https://www.freepik.com/" className="text-dark underline">Freepik</a>, Video: <a href="https://www.pexels.com/" className="text-dark underline">Pexels</a>
        </CopyrightText>
        <PoweredByText>Powered by: <a href="https://leapot.in/" className='text-primary'>Leapot Technologies</a></PoweredByText>
        <SocialMediaContainer>
          <SocialMediaLink href="https://www.facebook.com" target="_blank"><FaFacebookF /></SocialMediaLink>
          <SocialMediaLink href="https://twitter.com" target="_blank"><CiTwitter /></SocialMediaLink>
          <SocialMediaLink href="https://www.linkedin.com" target="_blank"><CiLinkedin /></SocialMediaLink>
          <SocialMediaLink href="https://www.instagram.com" target="_blank"><IoLogoInstagram /></SocialMediaLink>
          <SocialMediaLink href="https://www.google.com" target="_blank"><FaFirefoxBrowser /></SocialMediaLink>
        </SocialMediaContainer>
      </CopyrightSection>
    </FooterWrapper>
  )
}

export default Footer